<template>
  <div class="page_box">
    <el-row style="display: flex;height:100%;position: relative;"
            justify="space-between">
               <p class="boldTitle">学校列表</p> 
      <div style="width: 240px;overflow-y:scroll;background:#fff;position: relative;margin-top:40px;">
      
        <el-tree style="width: 210px;margin:0 20px 0 10px; padding: 0 0 10px 0;background:#fff"
                 :data="dataSource"
                 ref="treeData"
                 node-key="schoolId"
                  :props="{
                    isLeaf: 'leaf'
                  }"
                  :highlight-current="true"
                 @node-click="checkNode"
                 :load="loadNode"
                 lazy>
          <template v-slot="{ nodes, data }">
            <span class="custom-tree-node">
              <span style="margin-left:26px;"
                    v-if="data.deviceMonitorName"
                    class="customTreeItem">
                <!-- <img v-if="data.deviceMonitorType==1"
                     style="width:20px"
                     src="@/assets/img/edu/menu/qj.png"
                     alt="">
                <img v-if="data.deviceMonitorType==2"
                     style="width:20px"
                     src="@/assets/img/edu/menu/gd.png"
                     alt=""> -->
                <el-tooltip class="item" effect="dark" :content="data.deviceMonitorName" placement="top-start">
                <span style="display:inline-block;width: 100px;overflow: hidden;text-overflow:ellipsis"> {{ data.deviceMonitorName }}</span>
                </el-tooltip>
                <img v-if="checkNodeStr.includes(data.cameraIndexCode)"  src="@/assets/img/edu/canplay.png"
                     style="width:14px"
                     alt="">
              </span>

              <span class="customTreeItem"
                    v-else>
                <img class="active"
                     style="width:20px"
                     src="@/assets/img/edu/active.png"
                     alt="">
                <img class="inactive"
                     style="width:20px"
                     src="@/assets/img/edu/inactiveSchool.png"
                     alt="">
                {{ data.hxgSchoolName}}</span>
              <!-- <a v-if="data.deviceIndexCode"
                   @click="append(data)"> 播放 </a> -->
            </span>
          </template>
        </el-tree>

      </div>
      <div style="flex:1;">
        <div style="width:100%;height:calc(100%) ;background:#f1f4f9; position: relative; flex-wrap:wrap;display:flex;justify-content: flex-start;flex-wrap: wrap;">
          <template v-if="!full">
            <div 
                 v-for="(i,n) in checkedNodes"
                 :key="n"
                 :class="fullCode&&i&&i==fullCode? 'fullPlayer cameraItem':'cameraItem'"
                 @wheel="showinfor(i,$event)"
                 @click="changeposition(i,$event)">
              <div class="posClose"
                   v-if="i">
                   <p>{{checkedName[n]}} 违停抓拍设备</p> 
                <i @click.stop="close(n)"
                   class="el-icon-circle-close"
                   style="color:#fff;font-size:20px"></i>
              </div>
              <easy-player v-if="i"
                           :code="i" :ref="'easyplayer5'+i"></easy-player>
              <!-- <div class="floatControl "
                   style="top:40px;left:0;right:0"
                   v-if="i&&i.split('_')[1]==1">
                <div @click="rotate('up',i.split('_')[0])"
                     class="">
                  <i :style="playFocus=='up'&&currentcode==i.split('_')[0]?'color:#79BAFF!important':''"
                     class="el-icon-arrow-up"></i>
                </div>
              </div>
              <div class="floatControl "
                   style="top:0;right:40px;bottom:0"
                   v-if="i&&i.split('_')[1]==1">
                <div @click="rotate('right',i.split('_')[0])"
                     class="">
                  <i :style="playFocus=='right'&&currentcode==i.split('_')[0]?'color:#79BAFF!important':''"
                     class="el-icon-arrow-right"></i>
                </div>
              </div>
              <div class="floatControl "
                   style="bottom:40px;left:0;right:0"
                   v-if="i&&i.split('_')[1]==1">
                <div style="right:0;bottom:40px;left:0"
                     @click="rotate('down',i.split('_')[0])"
                     class="">
                  <i :style="playFocus=='down'&&currentcode==i.split('_')[0]?'color:#79BAFF!important':''"
                     class="el-icon-arrow-down"></i>
                </div>
              </div>
              <div class="floatControl "
                   style="left:40px; top:0;bottom:0"
                   v-if="i&&i.split('_')[1]==1">
                <div style="top:0;right:0;left:40px"
                     @click="rotate('left',i.split('_')[0])"
                     class="">
                  <i :style="playFocus=='left'&&currentcode==i.split('_')[0]?'color:#79BAFF!important':''"
                     class="el-icon-arrow-left"></i>
                </div>
              </div> -->
              <div v-if="!i" class="emptyBox">
                <img src="@/assets/bigCamera.png" alt="">
                  <p>暂无画面</p>
              </div>
              <div class="bottomBg"
                   v-if="i">
                <!-- <img src="@/assets/yt.png"
                     alt="">
                <img src="@/assets/ytact.png"
                     alt=""> -->
               
                     <img v-if="i&&i==fullCode"  @click.stop="fullScreen(i,n)"
                     src="@/assets/quitScreen.png"
                     alt="">
                      <img v-else @click.stop="fullScreen(i,n)"
                     src="@/assets/fullscreen.png"
                     alt="">
              </div>

            </div>
          </template>
         
          <!-- <template v-if="checkedNodes.length<4" >
              <div  v-for="(i,n) in  4-checkedNodes.length" :key="n" class="cameraItem" >

              </div>
              </template> -->
        </div>
        <!-- <div class="controlBox" style="height:40px">
               <div>
                四窗口 
                </div>   
            </div> -->
      </div>

    </el-row>

  </div>
</template>

<script>
import { Form } from 'element-ui';
//这里可以引入其他文件（比如组件，工具js，第三方插件js，json文件，图片文件等等）
//列如：import <<组件名称>> from '《组件路径》';
import EasyPlayer from './components/easyPlayer.vue'

export default {
  //import引入的组件需要注入到对象中才能使用
  name: "prelectionRecord",
  components: {
    EasyPlayer,
  },
  props: {},
  data () {
    //这里存放数据
    return {
      requestData: {
        page: 1,
        pageSize: 20,
        eduId: '',
      },
      eduInfo: JSON.parse(sessionStorage.getItem("eduInfo")),

      listParams: {
        cloudMeetingId: null,
        pageNum: 1,
        pageSize: 20,
      },
      tableData: [],
      total: 0,
      drawerShow: false,
      drawerType: "add",
      listShow: false,
      baseUrl: "https://safe.zzsasoft.com/research/api",
      initialData: {

      },
      dataSource: [],
      checkedNodes: ['', '', '', ''],
      checkedName: ['', '', '', ''],
      checkNodeStr:'',
      resolve: null,
      playFocus: "",
      currentcode: "",
      full:false,
      wheelWating:false,
      fullCode:"",
      fullType:"",
      currentFull:null,
      isFinish:false
    };
  },
  //监控data中的数据变化
  watch: {},
  //计算属性，类似于data概念
  computed: {
    
  },
  //方法集合
  methods: {
    async getList () {
      const faultList = await this.$playHttp.regionNodes({
        pageNo: 1,
        pageSize: 60,
        parentIndexCodes: this.eduInfo.eduId
      })
      this.dataSource = faultList.data
    },
    waitLazyLoaded (targetNode) {
      return new Promise((resolve, reject) => {
        // 保存resolve
        this.resolve = resolve
        // 展开节点（展开节点会自动触发懒加载，但是没有加载完成后的状态，所以保存resolve）
        targetNode.expand()
      })
    },


    close (n) {
      if(this.fullCode){
          this.currentFull=null
          this.fullCode=''
      }
      this.checkNodeStr=this.checkNodeStr.replace(this.checkedNodes[n],'')
      this.checkedNodes[n] = ''
      this.checkedName[n] = ''
      this.$set(this, 'checkedNodes', this.checkedNodes)
      this.$set(this, 'checkNodeStr', this.checkNodeStr)

      this.$forceUpdate()

    },
    checkNode (node, datas) {
      if (node.cameraIndexCode) {
        let index = this.checkedNodes.findIndex(item => item.includes(node.cameraIndexCode))
        if (index > -1) {
          this.checkNodeStr= this.checkNodeStr.replace(this.checkedNodes[index],'')
          this.checkedNodes[index] = ''
          this.checkedName[index] = ''

        } else {

          for (var i = 0; i < 4; i++) {
            if (!this.checkedNodes[i]) {
              this.checkedNodes[i] = node.cameraIndexCode;
              this.checkedName[i] = datas.parent.data.hxgSchoolName;
              this.checkNodeStr+=node.cameraIndexCode
              break
            }
          }

          // this.checkedNodes.push(node.cameraIndexCode)

        }
        if(this.fullCode){
          this.currentFull=null
          this.fullCode=''
        }
       this.$set(this, 'checkNodeStr', this.checkNodeStr)
        this.$set(this, 'checkedNodes', this.checkedNodes)
        this.$forceUpdate()
      } else {
        const targetNode = this.$refs.treeData.getNode(node)
        this.waitLazyLoaded(targetNode).then(fields => {


        }).finally(res => {

        })
      }

    },
    loadNode (node, resolve) {
        console.log(node)
      this.$nextTick(async () => {
        if (node.level == 0) {
          const faultList = await this.$Http.hxgCaptureSchoolList({ eduId: this.eduInfo.eduId})
          resolve(faultList.data)
        } else if (node.level == 1) {

          const newChild = await this.$Http.hxgCaptureDeviceList({
            schoolId: node.data.schoolId
          })
          if (!node.children) {
            node.children = []
          }
          if (newChild.data&&newChild.data.length) {
            newChild.data.forEach(data => {
              data.leaf = true
              data.schoolId = data.cameraIndexCode
              data.parentId = node.data.schoolId
              data.children = null

            });
            // tableQuery.value.parentIndexCodes = node.indexCode
            node.children = newChild.data
            this.resolve && this.resolve(newChild.data)
            resolve(newChild.data)

          }else{
                      resolve([])

          }
        } else {
          resolve([])
        }
      })
    },
    rotate (type, code, speed) {
      this.currentcode = code
      this.playFocus = type
      this.$playHttp.hxgCameraRotate({
        command: type,
        speed: speed ? speed : 50,
        cameraIndexCode: code,
        action: 0
      }).then(res => {
        if (res.code == 200) {
          setTimeout(() => {
            this.stop(type, code)
          }, 1);
        }
      }).finally(data => {
          this.isFinish=false
      })
    },
    stop (type, code, speed) {
      this.playFocus = ''
      this.currentcode = ''
      this.$playHttp.hxgCameraRotate({
        command: type,
        speed: speed ? speed : 50,
        cameraIndexCode: code,
        action: 1
      }).then(res => {
        if (res.code == 200) {
            
        }
      }).finally(data => {
          this.isFinish=false
      })
    },
    fullScreen (i, n) {
      
      // if(this.full){
      //   this.full=false
      //   return
      // }
      if(this.currentFull==n){
         this.fullCode=''
          this.currentFull=null
          return
      }
      this.currentFull = n
      this.fullCode=i
      // this.full=!this.full
    },
    changeposition (i, event) {
      if(this.isFinish) return
      // if (i && i.split('_')[1] != 1) return
      let fullEl =  document.getElementsByClassName('fullPlayer')
      if(this.fullCode==i){
      var width = fullEl&&fullEl.length?fullEl[0].clientWidth / 2:""
      var height =fullEl&&fullEl.length? fullEl[0].clientHeight / 2:""
      }else{
      var width = document.getElementsByClassName('cameraItem')[0].clientWidth / 2
      var height = document.getElementsByClassName('cameraItem')[0].clientHeight / 2
      }
     
      let targetX = event.layerX
      let targetY = event.clientY
      var pos1 = ''
      var pos2 = ''
      if (targetX - width > 50) {
        pos1 = 'Right'
      }
      if (targetX - width < -50) {
        pos1 = 'Left'
      }
      if (targetY - height > 50) {
        pos2 = 'Down'

      }
      if (targetY - height < -50) {
        pos2 = 'Up'
      }

      let pos = pos2 && pos1 ? pos1 + '_' + pos2 : pos1 ? pos1 : pos2 ? pos2 : ""
      this.isFinish=true
      this.rotate(pos, i)
    },
    showinfor (i, event) {
      // if (i && i.split('_')[1] != 1) return
      if (this.wheelWating) return
      this.wheelWating = true
      let type = ''
      if (event.deltaY > 0) {
        type = "zoom_out"
      } else {
        type = "zoom_in"
      }
      this.$playHttp.hxgCameraRotate({
        command: type,
        speed: 50,
        cameraIndexCode: i,
        action: 0
      }).then(res => {
        if (res.code == 200) {
          setTimeout(() => {
            this.$playHttp.hxgCameraRotate({
              command: type,
              speed:  75,
              cameraIndexCode: i,
              action: 1
            }).then(res => {
              if (res.code == 200) {
               this.wheelWating = false
              }
            }).finally(data => {

            })
          }, 1);
        }
      }).finally(data => {

      })
    },
     changepositionfull ( event) {
      if(this.isFinish) return
      if (this.fullType && this.fullType != 1) return
      let width = document.getElementsByClassName('fullPlayer')[0].clientWidth / 2
      let height = document.getElementsByClassName('fullPlayer')[0].clientHeight / 2
      let targetX = event.layerX
      let targetY = event.clientY
      var pos1 = ''
      var pos2 = ''
      if (targetX - width > 50) {
        pos1 = 'Right'
      }
      if (targetX - width < -50) {
        pos1 = 'Left'
      }
      if (targetY - height > 50) {
        pos2 = 'Down'

      }
      if (targetY - height < -50) {
        pos2 = 'Up'
      }
      let pos = pos2 && pos1 ? pos1 + '_' + pos2 : pos1 ? pos1 : pos2 ? pos2 : ""
      this.isFinish=true
      this.rotate(pos, this.fullCode)
    },
    showinforfull (i, event) {
      if (this.wheelWating) return
      this.wheelWating = true
      let type = ''
      if (event.deltaY > 0) {
        type = "zoom_out"
      } else {
        type = "zoom_in"
      }
      this.$playHttp.hxgCameraRotate({
        command: type,
        speed: 80,
        cameraIndexCode: this.fullCode,
        action: 0
      }).then(res => {
        if (res.code == 200) {
          setTimeout(() => {
            this.$playHttp.hxgCameraRotate({
              command: type,
              speed:  80,
              cameraIndexCode: this.fullCode,
              action: 1
            }).then(res => {
              if (res.code == 200) {
               this.wheelWating = false
              }
            }).finally(data => {

            })
          }, 1);
        }
      }).finally(data => {

      })
    }


  },
  //生命周期，创建完成（可以访问当前this实例）
  created () { },
  //生命周期，挂载完成（可以访问dom元素）
  mounted () {
    // this.requestData.cloudMeetingEdu = this.eduInfo.eduId
    // this.getList();
    // this.showLog({researchSafeId:21})
  },
  beforeCreate () { }, //生命周期-创建之前
  beforeMount () { }, //生命周期 - 挂载之前
  beforeUpdate () { }, //生命周期 - 更新之后
  updated () { }, //生命周期 - 更新之后
  beforeDestroy () { }, //生命周期 - 销毁之前
  destroy () { }, //生命周期 - 销毁完成
  activated () { } //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.cloudTitle {
  color: #000;
}
.cloudContent {
  color: #999;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/deep/.expanded {
  box-shadow: 0px 2px 10px 0px rgb(0 0 0 / 10%);
  position: relative;
  z-index: 9;
}
/deep/.el-table__expanded-cell {
  background: #f6f8fa !important;
  padding: 0 !important;
}

/deep/.enterPriseTable .el-table__cell {
  padding: 11px 0;
}
.page_table_box {
  height: calc(100% - 20px);
}
.school_table_box {
  margin-top: 20px;
  height: 86% !important;
}
.pagination_box {
  justify-content: flex-end;
}
/deep/.el-pager li {
  width: 22px;
  height: 22px;
  min-width: 22px;
  line-height: 22px;
}
/deep/.el-pager li.active {
  color: #fff !important;
  background-color: #416fff !important;
  border-radius: 2px;
}
/deep/.el-tree-node__content {
  padding: 8px 6px;
  min-height: 26px;
  border-radius: 4px;
  box-sizing: content-box;
  margin-top: 5px;
  font-family: PingFang SC;
  font-size: 14px;
  color: #1a1a1a;
  padding-left: 6px !important;
}
/deep/.edu_content_right {
  margin: 0;
}
.edu_content_right {
}
.page_box {

  padding-top: 1px;
}
.cameraItem {
  border-right: 0.5px solid #ced0b6;
  border-top: 0.5px solid #ced0b6;
  position: relative;
  display: inline-block;
  width: 50%;
  height: 50%;
}
.posClose {
  position: absolute;
  z-index: 999;
  background: rgb(31, 33, 40);
  width: 100%;
  height: 40px;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 20px;
}
.posClose p {
  color: #fff;

  margin: 0 0 0 20px;
}
.bottomBg {
  position: absolute;
  z-index: 999;
  background: rgb(31, 33, 40);
  width: 100%;
  height: 35px;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 10px;
}
.bottomBg img {
  width: 28px;
  margin-left: 10px;
  cursor: pointer;
}
.cameraItem .el-icon-circle-close {
  cursor: pointer;
}
.cameraItem:nth-child(1) {
  border-left: 0.5px solid #ced0b6;
}
.cameraItem:nth-child(3) {
  border-left: 0.5px solid #ced0b6;
  border-bottom: 1px solid #ced0b6;
}
.cameraItem:nth-child(4) {
  border-bottom: 1px solid #ced0b6;
}
.controlBox {
  color: #fff;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
}
/deep/ .el-tree .el-tree-nodes__content:last-child:before {
  display: none !important;
}
/deep/ .el-tree-node__content:hover,
/deep/ .el-tree-node:focus > .el-tree-node__content {
  background: rgba(2, 86, 255, 0.1) !important;
  color: #0256ff;
}

/deep/.el-checkbox__inner {
  border-radius: 50%;
  background: transparent;
  border: 1px solid #7796c5;
}
/deep/.is-checked .el-checkbox__inner {
  background: #0256ff;
}
/deep/.is-current .el-tree-node__content {
  background: rgba(2, 86, 255, 0.1) !important;
  color: #0256ff;
}
.customTreeItem {
  width: 180px;

  display: inline-flex;
  align-items: center;
  word-break: break-all;
  overflow: hidden;
  white-space: break-space;
}
.customTreeItem img {
  margin-right: 5px;
}
.active {
  color: #79baff !important ;
  /* font-size: 18px; */
  font-weight: 600;
}
.floatControl {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  width: 44px;
  height: 44px;

  margin: auto;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
}
.floatControl div {
  cursor: pointer;
  /* position: absolute; */
  margin: auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  width: 30px;
  left: 0;
  bottom: 0;
  top: 0;
  right: 0;
}
.right {
  top: 0;
  bottom: 0;
  right: 10px;
}
.left {
  top: 0;
  bottom: 0;
  left: 10px;
}
.top {
  top: 10px;
  right: 0;
  left: 0;
}
.bottom {
  bottom: 10px;
  right: 0;
  left: 0;
}
.floatControl i {
  color: #fff;
  font-size: 30px;
}
/deep/.el-tree-node__expand-icon {
  box-shadow: none;
}
.expanded {
  color: rgba(2, 86, 255, 0.1) !important;
}
.el-tree .el-tree-node__content {
  background: rgba(2, 86, 255, 0.1);
}
/deep/ .is-expanded .el-tree-node__children .el-tree-node__content {
  background: transparent !important;
  color: #1a1a1a;
}
.active {
  display: none;
}
.el-tree .is-expanded .active {
  display: block;
}
.el-tree .is-expanded .custom-tree-node {
}
.el-tree .is-expanded .inactive {
  display: none;
}
.fullPlayer{
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 9999;
  border: none;
}
.boldTitle{
  font-size: 16px;
font-weight: 500;
color: #1a1a1a;
position: absolute;
top: 0;
height: 40px;
line-height: 40px;
width: 240px;
padding-left: 24px;
background: #fff;
left: 0;
}
.emptyBox{
      position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: #1a1a1a;
}
.emptyBox img{
  width: 122px;
}
</style>
